import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FemaleIcon(props: IconProps) {
    return <Icon {...props} iconKey={"female"}/>
}
